import { atom } from 'jotai';

export const isLoading = atom<boolean>(false);
